export default __webpack_public_path__ + "static/media/icon_settingtype_BeadPave.f5f5b16b.png";